import {registerLanguage} from '@p4b/utils-lang';

function plural(x: number, ws: string[]): string {
    if (x >= 100) {
        return ws[4];
    } else if (x >= 10) {
        return ws[3];
    } else if (x >= 3) {
        return ws[2];
    } else if (x >= 2) {
        return ws[1];
    } else {
        return ws[0];
    }
}

registerLanguage('العربية', {
    LOCALE: 'ar',
    DIRECTION: 'RTL',
    LOGIN_INSTRUCTIONS: '<h1>الرجاء إدخال بيانات تسجيل الدخول</h1>',
    LOGIN_CANDIDATE_ID_LABEL: 'اسم المستخدم',
    LOGIN_PASSWORD_LABEL: 'كلمة المرور',
    LOGIN_BUTTON: 'تسجيل الدخول',
    FREE_SPACE: ({quota, used}) => `تم استخدام <bdi>${used}</bdi> ميجابايت من أصل <bdi>${quota}</bdi> ميتوفرةجابايت م`,

    CHOOSE_INSTRUCTIONS: ({cid}) => `<p><b>أنت مسجل كـ <bdi>${cid}</bdi></b></p>لست أنت؟ يرجى تسجيل الخروج والعودة بهويتك الصحيحة`,
    CHOOSE_PROCTORED_EXAMITY: `<h1>يرجى الضغط على "بدء&nbsp;المراقبة" للوصول إلى منصة <bdi>EXAMITY</bdi></h1><ul><li>لإنشاء ملفك الشخصي</li><li>للاتصال بالمراقب وبدء الامتحان الخاص بك</li></ul>`,
    CHOOSE_PROCTORED_GENERIC: ({proctorName}) => `<h1>يرجى الضغط على "بدء&nbsp;المراقبة" للوصول إلى منصة <bdi>${proctorName}</bdi></h1>`,
    CHOOSE_PROCTORED_SUPPORT: `إذا واجهت صعوبات في الاتصال بالمراقب، يرجى التواصل مع فريق دعم الامتحانات`,
    CHOOSE_NO_EXAMS: `<h1>لا توجد امتحانات متاحة لتقديمها حالياً</h1>`,
    CHOOSE_SELECT_EXAM: `<h1>يرجى اختيار الامتحان المطلوب</h1>`,
    CHOOSE_AUTO_START: `<h1>يرجى الانتظار، سيتم توصيلك تلقائياً عند فتح الامتحان.</h1>`,
    CHOOSE_AUTO_SUPPORT: `إذا لم يتم الاتصال بعد وقت بدء الامتحان، يرجى التواصل مع فريق دعم الامتحانات`,
    CHOOSE_MANUAL_START: `<h1>أدخل رمز <bdi>PIN</bdi> الذي تم تزويدك به</h1>`,
    CHOOSE_MANUAL_SUPPORT: `إذا واجهت صعوبات في بدء الامتحان، يرجى التواصل مع فريق دعم الامتحانات`,
    CHOOSE_PRESS_START: `<h1>انقر على "تأدية&nbsp;الامتحان&nbsp;المختار" للبدء</h1>`,
    CHOOSE_EXAM_LABEL: 'اختيار الامتحان',
    CHOOSE_MANUAL_PIN_LABEL: 'رمز <bdi>PIN</bdi> للامتحان',
    CHOOSE_AUTO_PIN_LABEL: 'رمز <bdi>PIN</bdi> للوضع غير المتصل',
    CHOOSE_EXAM_BUTTON: 'تأدية الامتحان المختار',
    CHOOSE_LOGOUT_BUTTON: 'تسجيل الخروج',
    CHOOSE_PROCTOR_BUTTON: 'بدء المراقبة',
    CHOOSE_PROCTOR_WAIT: 'يرجى الانتظار...',
    CHOOSE_EXAM_HINT: 'اختر الامتحان لتقديمه...',
    CHOOSE_WAITING_TO_START: 'امتحانات بانتظار البدء',
    CHOOSE_ALREADY_STARTED: 'امتحانات بدأت بالفعل',
    CHOOSE_OFFLINE_BUTTON: 'وضع العمل دون اتصال',

    ERROR_NETWORK: 'خطأ في الشبكة',
    ERROR_USER_PASS: '<b>فشل التحقق من الهوية. هذا الحساب غير موجود، أو أن بيانات الاعتماد غير صحيحة.</b>',
    ERROR_CONNECTION_TIMEOUT: 'انتهت مهلة الاتصال',
    ERROR_HTTP: ({code}) => `خطأ في الخادم${code ? ` (<bdi>HTTP ${code}</bdi>)` : ''}`,
    ERROR_PROXY: 'الخادم مزدحم حالياً، يرجى إعادة المحاولة',
    ERROR_UNKNOWN: ({message}) => `خطأ${message ? ` [<bdi>${message}</bdi>]` : ''}`,
    ERROR_STORAGE: "لقد نفدت مساحة التخزين لديك. يرجى توفير مساحة إضافية، أو الانتقال إلى جهاز آخر.",
    ERROR_PIN: '<b>رمز <bdi>PIN</bdi> غير صحيح، أو تم اختيار امتحان خاطئ</b>',
    ERROR_CANDIDATE_NOT_FOUND: 'تم إدخال معرف المستخدم بشكل غير صحيح، أو أنه غير مسجل في هذا الامتحان.',
    ERROR_RESEND: ({err}) => `<b><bdi>${err}</bdi></b><p> تعذر الاتصال بالخادم. يمكنك متابعة الامتحان في وضع العمل دون اتصال، وسيتم تخزين الإجابات محلياً على هذا الجهاز، ولكن سيلزم إرسالها إلى الخادم قبل أن تتمكن من إنهاء الامتحان. لن تظهر لك أي إجابات تم تقديمها مسبقاً من جهاز آخر. وفي حال عودة الاتصال بالشبكة، سيتم حفظ جميع الإجابات على الخادم تلقائياً.</p>`,
    ERROR_DOWNLOAD: 'تعذر تحميل الامتحان',

    DOWNLOAD_TITLE: ({downloadCount}) => `جاري تحميل <bdi>${downloadCount}</bdi> ${plural(downloadCount, ["امتحان", "امتحانين", "امتحانات", "امتحاناً", "امتحان"])}، يرجى الانتظار...`,
    DOWNLOAD_DESCRIPTION: ({freeSpace}) => `<p>قد يستغرق التحميل عدة دقائق حسب سرعة اتصالك بالشبكة</p>${freeSpace}`,
    DOWNLOAD_COUNT_EXCEEDED: ({examTitle}) => `تجاوزت حد التحميل: <bdi>${examTitle}</bdi>`,

    PREPARING_TITLE: 'جاري تحضير الامتحان، يرجى الانتظار...',
    PREPARING_DESCRIPTION: ({freeSpace}) => `<p>قد تستغرق عملية التحضير عدة دقائق بناءً على مواصفات جهاز الكمبيوتر الخاص بك.<p>${freeSpace}`,

    CONTROL_OVERVIEW: 'نظرة عامة',
    CONTROL_LANGUAGE: 'اللغة',
    CONTROL_FINISH: 'إنهاء',
    CONTROL_CALCULATOR: 'آلة حاسبة',
    CONTROL_COLOUR: 'اللون',
    CONTROL_VERSION: 'الإصدار',
    CONTROL_USERID: 'معرف المستخدم',
    CONTROL_PREVIOUS: 'السابق',
    CONTROL_NEXT: 'التالي',
    CONTROL_PREVIOUS_CASE: 'الحالة السابقة',
    CONTROL_NEXT_CASE: 'الحالة التالية',
    CONTROL_PREVIOUS_CANDIDATE: 'المتقدم السابق',
    CONTROL_NEXT_CANDIDATE: 'المتقدم التالي',
    CONTROL_PREVIOUS_STATION: 'المحطة السابقة',
    CONTROL_NEXT_STATION: 'المحطة التالية',
    CONTROL_NOTES: 'ملاحظات',
    CONTROL_CONNECT: 'اتصال',
    CONTROL_CONNECTING: 'جاري',
    CONTROL_DISCONNECT: 'قطع الاتصال',
    CONTROL_DISCONNECTING: 'قطع الاتصال',
    CONTROL_ID_VALIDATE: ({id}) => `اعتماد <bdi>${id}</bdi>`,
    CONTROL_ID_INVALIDATE: ({id}) => `إلغاء الاعتماد <bdi>${id}</bdi>`,
    CONTROL_MUTE: 'كتم الصوت',
    CONTROL_UNMUTE: 'إلغاء الكتم',
    CONTROL_CAMERA: 'الكاميرا',
    CONTROL_SPEAKERS: 'مكبرات الصوت',
    CONTROL_MICROPHONE: 'الميكروفون',
    CONTROL_HIGHLIGHT: 'تمييز / إلغاء التمييز',

    ID_CHECK_INVALIDATE_CONFIRM: 'هل أنت متأكد من أنك تريد إلغاء اعتماد هذه الهوية؟',

    TITLE_ROUND: 'جولة',
    TITLE_STATION: 'محطة',
    TITLE_CIRCUIT: 'مسار',
    TITLE_CASE: ({n, m}) => `الحالة&nbsp;<bdi><b>${n}</b></bdi>&nbsp;من&nbsp;<bdi><b>${m}</b></bdi>`,
    TITLE_QUESTION: ({n, m}) => `السؤال ${n} من ${m}`,
    TITLE_CONNECT_TO: ({factor}) => `الاتصال&nbsp;بـ&nbsp;<bdi>${factor}</bdi>`,

    NOTIFICATION_CONNECT: '<center>انقر على زر <b>الاتصال</b> أعلاه للبدء.</center>',
    NO_CANDIDATE: 'لا يوجد متقدم لهذه الجولة.',
    REST_STATION: 'هذه محطة استراحة.',

    MEETING_POOR_CONNECTION: 'اتصال ضعيف: قد تواجه مشكلات في جودة الصوت والفيديو.',
    MEETING_STATUS_ERROR: ({err}) => `حالة الخروج من الاجتماع: <bdi>${err}</bdi>`,

    TIMER_REMAINING: 'الوقت المتبقي',
    TIMER_ELAPSED: 'الوقت المنقضي',
    TIMER_ROUND_REMAINING: 'متبقي في الجولة',

    OVERVIEW_TITLE: 'نظرة عامة',
    OVERVIEW_NO_CANDIDATE: 'لا يوجد متقدم',
    RESOURCE_RESTRICTED_SHOW: 'عرض',
    RESOURCE_RESTRICTED_HIDE: 'إخفاء',

    ANSWER_OPTIONAL: 'اختياري',
    ANSWER_REQUIRED: 'إلزامي',
    ANSWER_TITLE: 'الإجابة',
    ANSWER_FLAG_TIP: 'تحديد هذا السؤال',
    SBA_ANSWER_TIP: 'اختيار هذه الإجابة',
    SBA_ELIMINATE_TIP: 'استبعاد هذه الإجابة',
    DROPDOWN_INSTRUCTIONS: 'استخدم مفاتيح الأسهم للتنقل. اضغط على Enter للتحديد.',
    NOT_ANSWERED: 'لم يتم الإجابة',

    PAUSED_TITLE: 'الامتحان متوقف مؤقتاً',
    PAUSED_DESCRIPTION: '<p>لقد تم إيقاف الامتحان <strong>مؤقتاً</strong> عن بُعد بواسطة المشرف.<p>',

    STOPPED_TITLE: 'انتهى الامتحان',
    STOPPED_CLEANUP: '<p>جاري التنظيف، يرجى الانتظار...<p>',

    MARKSHEET_INVALID: ({invalid}) => `المعايير الإلزامية التالية تتطلب ردًا:<br><br><b><bdi>${invalid}</bdi></b><br><br><div style="text-align: start"><b>موافق</b> - لمغادرة ورقة الدرجات هذه.<br><b>إلغاء</b> - للبقاء في ورقة الدرجات ومعرفة المعايير المفقودة.</div>`,

    FINISH_TITLE: 'هل أنت مستعد للإنهاء؟?',
    FINISH_DESCRIPTION: 'انقر على "إرسال&nbsp;الامتحان" قبل إغلاق علامة التبويب أو النافذة',
    FINISH_ANSWERED: 'لقد أجبت على جميع الأسئلة',
    FINISH_UNANSWERED: ({totalUnanswered}) => `لديك <bdi>${totalUnanswered}</bdi> ${plural(totalUnanswered, ["سؤال", "سؤالين", "أسئلة", "سؤالاً", "سؤال"])} غير ${plural(totalUnanswered, ["مجاب عليه", "مجاب عليهما", "مجاب عنها", "مجاب عنها", "مجاب عنها"])}`,
    FINISH_MANDATORY_UNANSWERED: ({totalUnanswered, mandatoryUnanswered}) => `لديك <bdi>${totalUnanswered}</bdi> ${plural(totalUnanswered, ["سؤال", "سؤالين", "أسئلة", "سؤالاً", "سؤال"])} غير مجاب عنها (<bdi>${mandatoryUnanswered}</bdi> ${plural(mandatoryUnanswered, ["إلزامي", "إلزاميان", "إلزامية", "إلزامية", "إلزامية"])})`,
    FINISH_SUBMITTED: '<p><b>لقد تم إرسال جميع إجاباتك إلى الخادم بنجاح.</b></p>',
    FINISH_UNSUBMITTED: ({unsubmitted, finished}: {unsubmitted: number; finished?: boolean}) => `<p>لديك <strong><bdi>${unsubmitted}</bdi></strong> ${plural(unsubmitted, ["إجابة", "إجابتان", "إجابات", "إجابة", "إجابة"])} غير ${plural(unsubmitted, ["مرسلة", "مرسلتان", "مرسلة", "مرسلة", "مرسلة"])} إلى الخادم.</p>
${finished ? '' : '<p>يمكنك إكمال الامتحان بأمان، حيث سيتم حفظ الإجابات على جهازك.</p>'}`,
    FINISH_CONTINUE: 'متابعة الامتحان',
    FINISH_NOW: 'إرسال الامتحان',

    INFO_TITLE: 'تعليمات',
    WARN_TITLE: 'تنبيه',
    ALERT_TITLE: 'حدث خطأ ما',
    ALERT_OK: 'موافق',
    ALERT_CANCEL: 'إلغاء',
    ALERT_RETRY: 'أعد المحاولة',
    ALERT_QUIT: 'خروج',
    ALERT_IGNORE: 'إلغاء',

    MEDIA_DEVICES_NOT_SUPPORTED: 'هذا المتصفح لا يدعم الكاميرات والميكروفونات',
    CAMERA_ERROR: 'خطأ في الوصول إلى الكاميرا',
    CAMERA_INSTRUCTIONS: ({err}) => `<p>[<bdi>${err}</bdi>]</p><ul><li>تأكد من أن جهازك يحتوي على كاميرا مدمجة، أو أنك قمت بتوصيل كاميرا خارجية</li><li>قد تحتاج إلى تفعيل الوصول إلى الكاميرا لـ <bdi><b>risr/</b>assess</bdi> في إعدادات الخصوصية والأمان بمتصفحك</li><li>قد تحتاج إلى تفعيل الوصول إلى الكاميرا لمتصفحك في إعدادات الخصوصية والأمان الخاصة بجهازك</li></ul>`,
    MICROPHONE_ERROR: 'خطأ في الوصول إلى الميكروفون',
    MICROPHONE_INSTRUCTIONS: ({err}) => `<p>[<bdi>${err}</bdi>]</p><ul><li>تأكد من أن جهازك يحتوي على ميكروفون مدمج، أو أنك قمت بتوصيل ميكروفون خارجي</li><li>قد تحتاج إلى تفعيل الوصول إلى الميكروفون لـ <bdi><b>risr/</b>assess</bdi> في إعدادات الخصوصية والأمان بمتصفحك</li><li>قد تحتاج إلى تفعيل الوصول إلى الميكروفون لمتصفحك في إعدادات الخصوصية والأمان الخاصة بجهازك</li></ul>`,
    NO_CAMERAS: 'لم يتم العثور على أي كاميرات',
    NO_MICROPHONES: 'لم يتم العثور على أي ميكروفونات',
    SCREEN_SHARE_PERMISSION: '<p>بالنسبة لهذا الامتحان، يجب عليك <i>السماح</i> بمشاركة شاشتك مع الممتحن.</p><ul><li>يجب عليك مشاركة الشاشة بأكملها؛ لذا إذا ظهرت لك خيارات، يجب عليك اختيار "الشاشة بأكملها" أو "كامل الشاشة" أو ما يعادلها.</li><li>قد تحتاج إلى السماح لـ <bdi><b>risr/</b>assess</bdi> بـ "مشاركة الشاشة" أو "تسجيل الشاشة" في إعدادات الخصوصية والأمان بمتصفحك</li><li>قد تحتاج إلى السماح لمتصفحك بـ "مشاركة الشاشة" أو "تسجيل الشاشة" في إعدادات الخصوصية والأمان الخاصة بجهازك</li></ul>',
    SCREEN_SHARE_FAILED: '<b>مشاركة الشاشة <i>محظورة</i> حالياً.</b>',

    VIEWER_RESET: 'إعادة ضبط العرض',
    VIEWER_SELECT: 'اختر إجراء النقر',
    VIEWER_PREV: 'الصفحة السابقة',
    VIEWER_NEXT: 'الصفحة التالية',
    VIEWER_FULLSCREEN: 'تبديل ملء الشاشة',
    VIEWER_CLOSE: 'إغلاق العارض',
    VIEWER_BROADCAST: 'بث التغييرات',
    VIEWER_UNDO: 'تراجع عن التغييرات',
    VIEWER_REDO: 'إعادة التغييرات',

    LOGOUT_MESSAGE: '<p>لقد سجلت خروجك حالياً، انقر أدناه لتسجيل الدخول.</p>',
    LOGIN_AGAIN: 'تسجيل الدخول',
    P4B_BACKGROUNDED: 'تم تعليق علامة التبويب هذه لأن هناك علامة تبويب أخرى لنظام <bdi><b>risr/</b>assess</bdi> نشطة حالياً. انقر على «موافق» للاستئناف.',
    NEWER_VERSION_AVAILABLE: ({version, latest}) => `<p>يتوفر إصدار أحدث من <bdi><b>risr/</b>assess</bdi></p><p>الإصدار المثبت: <bdi>${version}</bdi><br/>الإصدار المتوفر: <bdi>${latest}</bdi></p>`,

    SELECT_POINT: 'حدّد النقطة',
    CPQ_RESET: 'إعادة ضبط',
    WORD_COUNT: ({count}) => `${count} كلم${plural(count, ['ة', 'تان', 'ات', 'ة', 'ة'])}`,
    PVSA_MEDICATION: "الدواء",
    PVSA_DOSE: "الجرعة",
    PVSA_DOSE_UNIT: "الوحدة",
    PVSA_ROUTE: "طريق الإعطاء",
    PVSA_FREQUENCY: "التكرار",
    PVSA_MED_ADDED: "الدواء المضاف (للسوائل، عند الاقتضاء)",
    PVSA_DOSE_ADDED: "جرعة الدواء المضاف (للسوائل، عند الاقتضاء)",
    PVSA_DOSE_UNIT_ADDED: "وحدة الدواء المضاف (للسوائل، عند الاقتضاء)",
    PVSA_INVALID_OPTION: 'هذا الخيار غير متاح كإجابة',
});
